import React from "react";

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

const NotAuthorized = () => {
    return(
        <Container maxWidth="xl" >
        <br />
            <br />
            <br />
            <Typography color="text.primary">Nu sunteti autorizat pentru aceasta actiune</Typography>
            <br />
            <br />
            <br />
        </Container>
    );
}

export default NotAuthorized;